import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=5e78dcc6&scoped=true"
import script from "./tags.vue?vue&type=script&lang=js"
export * from "./tags.vue?vue&type=script&lang=js"
import style0 from "./tags.vue?vue&type=style&index=0&id=5e78dcc6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e78dcc6",
  null
  
)

export default component.exports